import { render, staticRenderFns } from "./FamousPediaItem.vue?vue&type=template&id=4480df9b&"
import script from "./FamousPediaItem.vue?vue&type=script&lang=js&"
export * from "./FamousPediaItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports